"use client"

import styled from "@emotion/styled"
import { Dialog, Drawer } from "@mui/material"
import { useTranslations } from "next-intl"
import { Dispatch, SetStateAction } from "react"
import { useIsDesktop } from "ui"
import ContactForm, { FormProjectProps } from "../../Form"
import PaymentForm, { PaymentFormProps } from "./PaymentForm"
import RentalHousingForm, { RentalHousingFormProps } from "./RentalHousingForm"

const StyledDrawer = styled(Drawer)`
  box-shadow: none;
  border: none;
  ::before {
    content: none;
  }
`

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 16px;
    max-width: 600px;
    width: calc(100% - 32px);
    max-height: 90vh;
    margin: 16px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    ${(props) => props.theme.breakpoints.down("md")} {
      width: 100%;
      margin: 0;
      border-radius: 16px 16px 0 0;
      align-self: flex-end;
    }
  }
  ${(props) => props.theme.breakpoints.down("md")} {
    .MuiDialog-container {
      align-items: flex-end;
    }
  }
`

type Props = {
  drawerOpen: boolean
  setDrawerOpen: Dispatch<SetStateAction<boolean>>
  formProps?: FormProjectProps | PaymentFormProps
  paymentForm?: boolean
  rentalHousingFormProps?: RentalHousingFormProps
}

const DrawerContactForm = ({
  drawerOpen,
  setDrawerOpen,
  formProps,
  paymentForm,
  rentalHousingFormProps,
}: Props) => {
  const isDesktop = useIsDesktop()
  const t = useTranslations("ProjectsPage")

  // Rental housing form opens as a centered modal
  if (rentalHousingFormProps) {
    return (
      <StyledDialog
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{ zIndex: 100000000 }}
      >
        <RentalHousingForm key={`${rentalHousingFormProps.preSelectedProject}-${rentalHousingFormProps.preSelectedRooms?.join(",")}`} {...rentalHousingFormProps} />
      </StyledDialog>
    )
  }

  return (
    <StyledDrawer
      anchor={isDesktop ? "left" : "bottom"}
      open={drawerOpen}
      transitionDuration={800}
      onClose={() => setDrawerOpen(false)}
      sx={{ zIndex: 100000000 }}
      SlideProps={{
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
      }}
      PaperProps={{
        sx: {
          width: { xs: "100%", md: 658 },
          height: { xs: "90%", md: "100%" },
          borderRadius: {
            xs: "16px 16px 0 0",
            md: 0,
          },
        },
      }}
    >
      {paymentForm ? (
        <PaymentForm
          {...(formProps as PaymentFormProps)}
          advancedPaymentTitle={t("advancePayment")}
        />
      ) : (
        <ContactForm {...(formProps as FormProjectProps)} title={t("leaveDetails")} />
      )}
    </StyledDrawer>
  )
}
export default DrawerContactForm
